// İptal Yönetimi (WMS) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.cancelManagement';

export const wmsCancelManagementGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'İptal Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Depoda iptal edilen siparişler (toplama sırasında ya da Sipariş Havuzu\'ndan) bu kuyruğa düşer. Pazaryeri / iade işlemini ofiste elle tamamlayıp kaydı burada "İşlendi" olarak işaretlersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık, Depo, Yenile'),
    filters: t(`${G}.regions.filters`, 'Sekmeler, arama, Gelişmiş Filtre'),
    table: t(`${G}.regions.table`, 'İptal kayıtları'),
    pagination: t(`${G}.regions.pagination`, 'Önceki / Sonraki'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Depoyu seçin'),
      text: t(`${G}.s1.text`, 'Sağ üstten akıllı depoyu seçin; yenile düğmesi listeyi tazeler.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Kayıtları süzün'),
      text: t(`${G}.s2.text`, '"Onay bekleyen" sekmesi henüz işlenmemiş iptalleri (yanında sayısıyla), "İşlenen" işaretlenmiş olanları, "Tümü" hepsini gösterir. Sipariş no veya müşteri adını yazıp "Ara"ya ya da Enter\'a basın. "Gelişmiş Filtre" ile durum, iptal tarih aralığı ve kaynağa (Toplama, Sipariş Havuzu, Manuel, E-ticaret) göre süzün.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. İptal kaydını okuyun'),
      text: t(`${G}.s3.text`, 'Her satırda sipariş no ve kalem sayısı, müşteri, kanal (pazaryeri), iptal sebebi ve varsa açıklaması, kaynak (iptalin nerede yapıldığı), iptal eden, tarih ve durum (Onay bekliyor / İşlendi) görünür.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Stok ne oldu?'),
      text: t(`${G}.s4.text`, 'Stok, sipariş iptal edildiği anda zaten düzeltilmiştir: siparişten toplanmış ürünler stoğa geri eklenir ve "WMS toplama iptali stok iadesi" hareketi yazılır. Geri ekleme öncelikle sipariş kaleminin rafına yapılır; o raf yoksa ürünün stoğu olan başka bir toplanabilir rafa. Toplanmış ürünü fiziksel olarak rafa geri koymayı unutmayın.'),
      tips: [
        t(`${G}.s4.tip1`, 'Sipariş e-ticaret sitenizden geldiyse iptal anında orada da "İptal Edildi" yapılır. Pazaryeri (Trendyol, Hepsiburada vb.) iptali ve müşteri iadesi ise ofiste elle yapılır.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. İşlendi olarak onaylayın'),
      text: t(`${G}.s5.text`, 'Pazaryeri iptal / iade işlemini tamamladıktan sonra satırdaki "Onayla" düğmesine basın, isterseniz "İşlem notu" yazıp onaylayın. Kayıt "İşlenen" sekmesine taşınır ve onaylayan kişinin adı kaydedilir. Onay stoğu değiştirmez; yalnız kaydın işlendiğini işaretler.'),
    },
  ],
});
